// extracted by mini-css-extract-plugin
export default {"ccBackBtn":"back-btn_ccBackBtn__-N8Gm"};